import { render } from "./practice-spline-chart.vue?vue&type=template&id=4a7a06c1"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__